import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const FAQ = [
  {
    q: "How quickly will I receive my quote?",
    a: "Most quotes are emailed back within 24 hours. Larger commercial bids may require an on-site walk-through — we'll let you know within the first business day.",
  },
  {
    q: "Are your cleaners insured and bonded?",
    a: "Yes. Premier carries general liability coverage and our crews are W-2, background-checked, and bonded. We send documentation to property managers and contractors on request.",
  },
  {
    q: "What's included in a post-construction clean?",
    a: "Rough, final, and touch-up phases. We handle HEPA dust removal, glass and fixture polish, debris haul-out, floor finishing prep, and a punch-list walk before handoff.",
  },
  {
    q: "Do you do recurring commercial cleaning?",
    a: "Absolutely — nightly, weekly, or monthly schedules with assigned crews, a day porter option, and detailed quality control reports per visit.",
  },
  {
    q: "How does the $100 referral reward work?",
    a: "Refer any client by phone or email. Once they book and complete their first cleaning with us, we send you $100 — no cap. Tell us their name when you refer them.",
  },
];

export const FAQSection = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-24 lg:py-32 bg-[#050505]">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <Reveal className="text-center mb-14">
          <div className="overline text-[#D4AF37] mb-4">Questions</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-tight">
            Everything you might
            <br /><span className="gold-grad-text italic">want to know.</span>
          </h2>
        </Reveal>

        <div className="space-y-3">
          {FAQ.map((item, i) => (
            <Reveal key={i} delay={i * 80}>
              <div
                className={`card-surface rounded-2xl overflow-hidden transition-all ${open === i ? "border-[#D4AF37]/40" : ""}`}
              >
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full text-left p-6 flex items-center justify-between gap-4"
                  data-testid={`faq-toggle-${i}`}
                >
                  <h3 className="font-serif-display text-lg lg:text-xl text-white pr-4">{item.q}</h3>
                  <div className={`shrink-0 h-9 w-9 rounded-full border border-[#D4AF37]/40 flex items-center justify-center transition-colors ${open === i ? "bg-[#D4AF37] text-black" : "text-[#D4AF37]"}`}>
                    {open === i ? <Minus size={16} /> : <Plus size={16} />}
                  </div>
                </button>
                <div
                  className={`grid transition-[grid-template-rows] duration-300 ease-out ${open === i ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-white/65 leading-relaxed text-sm lg:text-base">{item.a}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
